import type { ReleaseNote } from "../content/releaseNotes"

const RELEASE_NOTES_READ_STORAGE_KEY = "stockerra:lastReadReleaseNote"
const RELEASE_NOTES_READ_EVENT = "stockerra:release-notes-read"

export const getReleaseNoteKey = (release?: ReleaseNote) => {
  if (!release) {
    return ""
  }
  return `${release.releaseDate}:${release.releaseLabel}`
}

export const hasUnreadReleaseNote = (latestRelease?: ReleaseNote) => {
  if (typeof window === "undefined") {
    return false
  }
  const latestKey = getReleaseNoteKey(latestRelease)
  if (!latestKey) {
    return false
  }
  return localStorage.getItem(RELEASE_NOTES_READ_STORAGE_KEY) !== latestKey
}

export const markReleaseNoteRead = (latestRelease?: ReleaseNote) => {
  if (typeof window === "undefined") {
    return
  }
  const latestKey = getReleaseNoteKey(latestRelease)
  if (!latestKey) {
    return
  }
  localStorage.setItem(RELEASE_NOTES_READ_STORAGE_KEY, latestKey)
  window.dispatchEvent(new Event(RELEASE_NOTES_READ_EVENT))
}

export const addReleaseNotesReadListener = (listener: () => void) => {
  if (typeof window === "undefined") {
    return () => {}
  }
  const handleStorage = (event: StorageEvent) => {
    if (event.key === RELEASE_NOTES_READ_STORAGE_KEY) {
      listener()
    }
  }
  window.addEventListener(RELEASE_NOTES_READ_EVENT, listener)
  window.addEventListener("storage", handleStorage)
  return () => {
    window.removeEventListener(RELEASE_NOTES_READ_EVENT, listener)
    window.removeEventListener("storage", handleStorage)
  }
}
